// extracted by mini-css-extract-plugin
export default {"container":"MessageBlock_container__7x3sT","title":"MessageBlock_title__b3RZL"};